export default __webpack_public_path__ + "images/7f1df4cd37bcbc54c374f56410bc54e3.png";